import React from 'react';
import OfferBar from '../OfferBar';
import ProjectCard from '../ProjectCard';
import { content } from '../../content';
import { Project, ViewMode } from '../../types';

type ProjectsSectionProps = {
  view: ViewMode;
  onOpen: (project: Project) => void;
};

/* Offer, then the work. Reviews have their own section in the nav now, and
   the ask that closes the page is rendered by App under every section. */
const ProjectsSection = ({ view, onOpen }: ProjectsSectionProps) => (
  <>
    <OfferBar />

    <div className={`projects projects--${view}`}>
      {content.projects.map((project, index) => (
        <ProjectCard
          key={project.id}
          project={project}
          onOpen={onOpen}
          index={index}
        />
      ))}
    </div>
  </>
);

export default ProjectsSection;
